<template>
    <b-card>
        <b-card-title>
            Manuella bokningar  <b-button variant="light" size="sm" title="Se instruktionsfilm" @click="openWindow('https://rexel.logivia.se/media/CloserTMS-ManuellaBokningar.mp4')">
                <font-awesome-icon :icon="['fas', 'envelope']"></font-awesome-icon>
                <i class="fa-solid fa-circle-info"></i>&nbsp;<i class="fa-solid fa-film"></i> Instruktionsfilm</b-button>
        </b-card-title>
        <b-card-body>
            <b-button variant="outline-secondary" :title="`Skapa bokning: ${t.title}`" v-for="(t,i) in getTemplates()"
                :key="i" @click="startNewBooking(t)">+ {{
                t.title }}</b-button>&nbsp;
        </b-card-body>
        <queryviewlistdetail qvtype="ManualBookings" ref="blist" title="Fraktdetaljer" :selectable="true"
            v-bind:extrafilter="extrafilter"
            v-on:rowclicked="onclick" :hovericons="[]" v-bind:currentkey="currId"
            v-on:currentkeychanged="oncurrentkeychanged" :detailsvisible="myModal" @close="onCloseDetails"
            :isBusy="isBusy">
            <template v-slot:details>
                <bookingltd v-if="currBook" :bookingtemplate="currTemplate" :readonly="currBook.booking.Locked"
                    :booking="currBook" @change="BookingChanged" @release="ReleaseBooking"
                    @deletebooking="DeleteBooking">
                </bookingltd>
            </template>
        </queryviewlistdetail>
        <lmodal title="Ny bokning" v-model="newBookingVisible" @ok="newBookingVisible=false" :domain="qvtype" @close="onCloseDetails">
            <bookingltd :bookingtemplate="currTemplate" :readonly="false" :booking="currBook" @change="BookingChanged"
                @release="ReleaseBooking" @deletebooking="DeleteBooking">
            </bookingltd>
        </lmodal>     
        <!-- <b-modal ok-only v-model="newBookingVisible" size="xl" title="Ny bokning">
            <bookingltd :bookingtemplate="currTemplate" :readonly="false" :booking="currBook" @change="BookingChanged"
                @release="ReleaseBooking" @deletebooking="DeleteBooking">
            </bookingltd>
        </b-modal> -->
    </b-card>
</template>

<script>
import User from "../../lib/user";
const usr = new User();
import moment from "moment";
import queryviewlistdetail from "./../queryview/queryviewlistdetail";
import lmodal from "@/components/l-modal.vue";

import { Api } from "../../lib/api";
const api = new Api();

import bookingltd from './bookingltd.vue';

//TODO: Read from db or at least config file
const templates = [
{
        name: 'PROJEKTPACK',
        title: 'Projektpack',
        permission: 'PROJECTPACK',
        default: {
            ServiceTypeId: 15,            
        },
        fields: {
            visibility: [
                { name: 'EtaMin', visible: false },
                { name: 'EtaMax', visible: false },
                { name: 'StatusId', visible: false },
                { name: 'TourName', visible: false },
                { name: 'ProductTerminalCombo', visible: true },
                { name: 'ProductKey', visible: false },
                { name: 'TerminalId', visible: false },
                { name: 'ServiceTypeId', visible: false },
            ],
            validation: [
                {name:'ProductKey',title:'Produkt',required:true,minval:null,maxval:null,minlength:null,maxlength:null},
                {name:'TerminalId',title:'Terminal',required:true,minval:null,maxval:null,minlength:null,maxlength:null},
                {name:'ServiceTypeId',title:'Ordertyp',required:true,minval:null,maxval:null,minlength:null,maxlength:null},
                {name:'Weight',title:'Vikt',required:true,minval:0.1,maxval:37000,minlength:null,maxlength:null},
                
                {name:'PickupPlaceName',title:'Hämtnamn',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                {name:'PickupPlaceStreet',title:'Hämtadress',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                {name:'PickupPlacePostCode',title:'Hämtpostnr',required:true,minval:10000,maxval:99999,minlength:5,maxlength:5},
                {name:'PickupPlaceCity',title:'Hämtort',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                {name:'DeliveryPlaceName',title:'Leveransnamn',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                {name:'DeliveryPlaceStreet',title:'Leveransadress',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                {name:'DeliveryPlacePostCode',title:'Leveranspostnr',required:true,minval:10000,maxval:99999,minlength:5,maxlength:5},
                {name:'DeliveryPlaceCity',title:'Leveransort',required:true,minval:null,maxval:null,minlength:null,maxlength:50},

                // {name:'DeliveryEmail',title:'Epost (mottagare)',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                {name:'DeliveryPhone',title:'Mobiltelefon (mottagare)',required:true,minval:null,maxval:null,minlength:null,maxlength:25},

            ]
        },
        basics: {
            products: [
            ],
            packageTypes: [
                // { TypeOfColli: "BA", PackageType: "Fat", PrintText: "FAT" },
                { TypeOfColli: "BE", PackageType: "Bunt", PrintText: "BUNT" },
                // { TypeOfColli: "BL", PackageType: "Bal", PrintText: "BAL" },
                // { TypeOfColli: "BO", PackageType: "Flaska", PrintText: "FLSK" },
                // { TypeOfColli: "BX", PackageType: "Låda", PrintText: "LÅDA" },
                // { TypeOfColli: "CON", PackageType: "Container (sjöfrakt)", PrintText: "CONT" },
                { TypeOfColli: "CR", PackageType: "Häck", PrintText: "HÄCK" },
                { TypeOfColli: "CT", PackageType: "Kartong", PrintText: "KART" },
                // { TypeOfColli: "CX", PackageType: "Dunk", PrintText: "DUNK" },
                { TypeOfColli: "DR", PackageType: "Trumma", PrintText: "TRUM" },
                // { TypeOfColli: "EP", PackageType: "EUR-pall", PrintText: "EURP" },
                // { TypeOfColli: "NE", PackageType: "Oemballerat", PrintText: "OEMB" },
                { TypeOfColli: "OP", PackageType: "Envägspall", PrintText: "PALL" },
                // { TypeOfColli: "PC", PackageType: "Paket", PrintText: "PKT" },
                // { TypeOfColli: "RO", PackageType: "Rulle", PrintText: "RULL" },
                // { TypeOfColli: "SA", PackageType: "Säck", PrintText: "SÄCK" },
                // { TypeOfColli: "TK", PackageType: "Tank, rektangulär", PrintText: "TANK" },
                { TypeOfColli: "XP", PackageType: "Pall (övriga)", PrintText: "PALL" },
            ],
            serviceTypes: [
                {
                    "ServiceTypeId": 15,
                    "Name": "Manuell order",
                    "TsrCode": null
                }
            ]
        }
    },
    {
        name: 'BUTIKSRETURJORDBRO',
        title: 'Butiksretur Jordbro',
        permission: 'ADM,STORE',
        default: {
            ServiceTypeId: 150,
            DeliveryPlaceName: 'Rexel DC Jordbro',
            DeliveryPlaceStreet: 'Silovägen 7',
            DeliveryPlaceStreet2: 'Godsmottagn öppen 06.30-11.00',
            DeliveryPlacePostCode: '13650',
            DeliveryPlaceCity: 'Jordbro',
        },
        fields: {
            visibility: [
                { name: 'EtaMin', visible: false },
                { name: 'EtaMax', visible: false },
                { name: 'StatusId', visible: false },
                { name: 'TourName', visible: false },
                { name: 'ProductTerminalCombo', visible: true },
                { name: 'ProductKey', visible: false },
                { name: 'TerminalId', visible: false },
                { name: 'ServiceTypeId', visible: false },
            ],
            validation: [
                {name:'ProductKey',title:'Produkt',required:true,minval:null,maxval:null,minlength:null,maxlength:null},
                {name:'TerminalId',title:'Terminal',required:true,minval:null,maxval:null,minlength:null,maxlength:null},
                {name:'ServiceTypeId',title:'Ordertyp',required:true,minval:null,maxval:null,minlength:null,maxlength:null},
                {name:'Weight',title:'Vikt',required:true,minval:0.1,maxval:37000,minlength:null,maxlength:null},
                
                {name:'PickupPlaceName',title:'Hämtnamn',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                {name:'PickupPlaceStreet',title:'Hämtadress',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                {name:'PickupPlacePostCode',title:'Hämtpostnr',required:true,minval:10000,maxval:99999,minlength:5,maxlength:5},
                {name:'PickupPlaceCity',title:'Hämtort',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                {name:'DeliveryPlaceName',title:'Leveransnamn',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                {name:'DeliveryPlaceStreet',title:'Leveransadress',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                {name:'DeliveryPlacePostCode',title:'Leveranspostnr',required:true,minval:10000,maxval:99999,minlength:5,maxlength:5},
                {name:'DeliveryPlaceCity',title:'Leveransort',required:true,minval:null,maxval:null,minlength:null,maxlength:50},

                // {name:'DeliveryEmail',title:'Epost (mottagare)',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                {name:'DeliveryPhone',title:'Mobiltelefon (mottagare)',required:false,minval:null,maxval:null,minlength:null,maxlength:25},

            ]
        },
        basics: {
            products: [
            ],
            packageTypes: [
                // { TypeOfColli: "BA", PackageType: "Fat", PrintText: "FAT" },
                { TypeOfColli: "BE", PackageType: "Bunt", PrintText: "BUNT" },
                // { TypeOfColli: "BL", PackageType: "Bal", PrintText: "BAL" },
                // { TypeOfColli: "BO", PackageType: "Flaska", PrintText: "FLSK" },
                // { TypeOfColli: "BX", PackageType: "Låda", PrintText: "LÅDA" },
                // { TypeOfColli: "CON", PackageType: "Container (sjöfrakt)", PrintText: "CONT" },
                { TypeOfColli: "CR", PackageType: "Häck", PrintText: "HÄCK" },
                { TypeOfColli: "CT", PackageType: "Kartong", PrintText: "KART" },
                // { TypeOfColli: "CX", PackageType: "Dunk", PrintText: "DUNK" },
                { TypeOfColli: "DR", PackageType: "Trumma", PrintText: "TRUM" },
                // { TypeOfColli: "EP", PackageType: "EUR-pall", PrintText: "EURP" },
                // { TypeOfColli: "NE", PackageType: "Oemballerat", PrintText: "OEMB" },
                { TypeOfColli: "OP", PackageType: "Envägspall", PrintText: "PALL" },
                // { TypeOfColli: "PC", PackageType: "Paket", PrintText: "PKT" },
                // { TypeOfColli: "RO", PackageType: "Rulle", PrintText: "RULL" },
                // { TypeOfColli: "SA", PackageType: "Säck", PrintText: "SÄCK" },
                // { TypeOfColli: "TK", PackageType: "Tank, rektangulär", PrintText: "TANK" },
                { TypeOfColli: "XP", PackageType: "Pall (övriga)", PrintText: "PALL" },
            ],
            serviceTypes: [
                {
                    "ServiceTypeId": 150,
                    "Name": "Butiksretur",
                    "TsrCode": null
                }
            ]
        }
    },
    {
        name: 'BUTIKSRETURGÖTA',
        title: 'Butiksretur Göta',
        permission: 'ADM,STORE',        
        default: {
            ServiceTypeId: 150,
            DeliveryPlaceName: 'Rexel DC Göta',
            DeliveryPlaceStreet: 'Stenhusvägen 5',
            DeliveryPlaceStreet2: 'Godsmottagn öppen 07.00-15.00',
            DeliveryPlacePostCode: '46335',
            DeliveryPlaceCity: 'Göta',
        },
        fields: {
            visibility: [
                { name: 'EtaMin', visible: false },
                { name: 'EtaMax', visible: false },
                { name: 'StatusId', visible: false },
                { name: 'TourName', visible: false },                
                { name: 'ProductTerminalCombo', visible: true },
                { name: 'ProductKey', visible: false },
                { name: 'TerminalId', visible: false },
                
                
            ],
            validation: [
                {name:'ProductKey',title:'Produkt',required:true,minval:null,maxval:null,minlength:null,maxlength:null},
                {name:'TerminalId',title:'Terminal',required:true,minval:null,maxval:null,minlength:null,maxlength:null},
                {name:'ServiceTypeId',title:'Ordertyp',required:true,minval:null,maxval:null,minlength:null,maxlength:null},
                {name:'Weight',title:'Vikt',required:true,minval:0.1,maxval:37000,minlength:null,maxlength:null},
                
                {name:'PickupPlaceName',title:'Hämtnamn',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                {name:'PickupPlaceStreet',title:'Hämtadress',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                {name:'PickupPlacePostCode',title:'Hämtpostnr',required:true,minval:10000,maxval:99999,minlength:5,maxlength:5},
                {name:'PickupPlaceCity',title:'Hämtort',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                {name:'DeliveryPlaceName',title:'Leveransnamn',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                {name:'DeliveryPlaceStreet',title:'Leveransadress',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                {name:'DeliveryPlacePostCode',title:'Leveranspostnr',required:true,minval:10000,maxval:99999,minlength:5,maxlength:5},
                {name:'DeliveryPlaceCity',title:'Leveransort',required:true,minval:null,maxval:null,minlength:null,maxlength:50},

                // {name:'ContactEmail',title:'Epost',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                // {name:'ContactPhone',title:'Mobiltelefon',required:true,minval:null,maxval:null,minlength:null,maxlength:25},
                {name:'DeliveryPhone',title:'Mobiltelefon (mottagare)',required:false,minval:null,maxval:null,minlength:null,maxlength:25},
            ]
        },
        basics: {
            products: [
            ],
            packageTypes: [
                // { TypeOfColli: "BA", PackageType: "Fat", PrintText: "FAT" },
                { TypeOfColli: "BE", PackageType: "Bunt", PrintText: "BUNT" },
                // { TypeOfColli: "BL", PackageType: "Bal", PrintText: "BAL" },
                // { TypeOfColli: "BO", PackageType: "Flaska", PrintText: "FLSK" },
                // { TypeOfColli: "BX", PackageType: "Låda", PrintText: "LÅDA" },
                // { TypeOfColli: "CON", PackageType: "Container (sjöfrakt)", PrintText: "CONT" },
                { TypeOfColli: "CR", PackageType: "Häck", PrintText: "HÄCK" },
                { TypeOfColli: "CT", PackageType: "Kartong", PrintText: "KART" },
                // { TypeOfColli: "CX", PackageType: "Dunk", PrintText: "DUNK" },
                { TypeOfColli: "DR", PackageType: "Trumma", PrintText: "TRUM" },
                // { TypeOfColli: "EP", PackageType: "EUR-pall", PrintText: "EURP" },
                // { TypeOfColli: "NE", PackageType: "Oemballerat", PrintText: "OEMB" },
                { TypeOfColli: "OP", PackageType: "Envägspall", PrintText: "PALL" },
                // { TypeOfColli: "PC", PackageType: "Paket", PrintText: "PKT" },
                // { TypeOfColli: "RO", PackageType: "Rulle", PrintText: "RULL" },
                // { TypeOfColli: "SA", PackageType: "Säck", PrintText: "SÄCK" },
                // { TypeOfColli: "TK", PackageType: "Tank, rektangulär", PrintText: "TANK" },
                { TypeOfColli: "XP", PackageType: "Pall (övriga)", PrintText: "PALL" },
            ],
            serviceTypes: [
                {
                    "ServiceTypeId": 150,
                    "Name": "Butiksretur",
                    "TsrCode": null
                }
            ]
        }
    },
    {
        name: 'LEVERANTÖRSRETUR',
        title: 'Leverantörsretur',
        permission: 'ADM,STORE',
        default: {
            ServiceTypeId: 150,
        },
        fields: {
            visibility: [
                { name: 'EtaMin', visible: false },
                { name: 'EtaMax', visible: false },
                { name: 'StatusId', visible: false },
                { name: 'TourName', visible: false },
                { name: 'ProductTerminalCombo', visible: true },
                { name: 'ProductKey', visible: false },
                { name: 'TerminalId', visible: false },
                { name: 'ServiceTypeId', visible: false },
            ],
            validation: [
                {name:'ProductKey',title:'Produkt',required:true,minval:null,maxval:null,minlength:null,maxlength:null},
                {name:'TerminalId',title:'Terminal',required:true,minval:null,maxval:null,minlength:null,maxlength:null},
                {name:'ServiceTypeId',title:'Ordertyp',required:true,minval:null,maxval:null,minlength:null,maxlength:null},
                {name:'Weight',title:'Vikt',required:true,minval:0.1,maxval:37000,minlength:null,maxlength:null},
                
                {name:'PickupPlaceName',title:'Hämtnamn',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                {name:'PickupPlaceStreet',title:'Hämtadress',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                {name:'PickupPlacePostCode',title:'Hämtpostnr',required:true,minval:10000,maxval:99999,minlength:5,maxlength:5},
                {name:'PickupPlaceCity',title:'Hämtort',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                {name:'DeliveryPlaceName',title:'Leveransnamn',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                {name:'DeliveryPlaceStreet',title:'Leveransadress',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                {name:'DeliveryPlacePostCode',title:'Leveranspostnr',required:true,minval:10000,maxval:99999,minlength:5,maxlength:5},
                {name:'DeliveryPlaceCity',title:'Leveransort',required:true,minval:null,maxval:null,minlength:null,maxlength:50},

                // {name:'ContactEmail',title:'Epost',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                // {name:'ContactPhone',title:'Mobiltelefon',required:true,minval:null,maxval:null,minlength:null,maxlength:25},
                {name:'DeliveryPhone',title:'Mobiltelefon (mottagare)',required:false,minval:null,maxval:null,minlength:null,maxlength:25},
            ]
        },
        basics: {
            products: [
            ],
            packageTypes: [
                // { TypeOfColli: "BA", PackageType: "Fat", PrintText: "FAT" },
                { TypeOfColli: "BE", PackageType: "Bunt", PrintText: "BUNT" },
                // { TypeOfColli: "BL", PackageType: "Bal", PrintText: "BAL" },
                // { TypeOfColli: "BO", PackageType: "Flaska", PrintText: "FLSK" },
                // { TypeOfColli: "BX", PackageType: "Låda", PrintText: "LÅDA" },
                // { TypeOfColli: "CON", PackageType: "Container (sjöfrakt)", PrintText: "CONT" },
                { TypeOfColli: "CR", PackageType: "Häck", PrintText: "HÄCK" },
                { TypeOfColli: "CT", PackageType: "Kartong", PrintText: "KART" },
                // { TypeOfColli: "CX", PackageType: "Dunk", PrintText: "DUNK" },
                { TypeOfColli: "DR", PackageType: "Trumma", PrintText: "TRUM" },
                // { TypeOfColli: "EP", PackageType: "EUR-pall", PrintText: "EURP" },
                // { TypeOfColli: "NE", PackageType: "Oemballerat", PrintText: "OEMB" },
                { TypeOfColli: "OP", PackageType: "Envägspall", PrintText: "PALL" },
                // { TypeOfColli: "PC", PackageType: "Paket", PrintText: "PKT" },
                // { TypeOfColli: "RO", PackageType: "Rulle", PrintText: "RULL" },
                // { TypeOfColli: "SA", PackageType: "Säck", PrintText: "SÄCK" },
                // { TypeOfColli: "TK", PackageType: "Tank, rektangulär", PrintText: "TANK" },
                { TypeOfColli: "XP", PackageType: "Pall (övriga)", PrintText: "PALL" },
            ],
            serviceTypes: [
                {
                    "ServiceTypeId": 150,
                    "Name": "Butiksretur",
                    "TsrCode": null
                }
            ]
        }
    },
    {
        name: 'MANUELLORDER',
        title: 'Manuell order',
        permission: 'ADM,STORE',
        default: {
            ServiceTypeId: 15,
        },
        fields: {
            visibility: [
                { name: 'EtaMin', visible: false },
                { name: 'EtaMax', visible: false },
                { name: 'StatusId', visible: false },
                { name: 'TourName', visible: false },
                { name: 'ProductTerminalCombo', visible: true },
                { name: 'ProductKey', visible: false },
                { name: 'TerminalId', visible: false },
                { name: 'ServiceTypeId', visible: false },
            ],
            validation: [
                {name:'ProductKey',title:'Produkt',required:true,minval:null,maxval:null,minlength:null,maxlength:null},
                {name:'TerminalId',title:'Terminal',required:true,minval:null,maxval:null,minlength:null,maxlength:null},
                {name:'ServiceTypeId',title:'Ordertyp',required:true,minval:null,maxval:null,minlength:null,maxlength:null},
                {name:'Weight',title:'Vikt',required:true,minval:0.1,maxval:37000,minlength:null,maxlength:null},
                
                {name:'PickupPlaceName',title:'Hämtnamn',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                {name:'PickupPlaceStreet',title:'Hämtadress',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                {name:'PickupPlacePostCode',title:'Hämtpostnr',required:true,minval:10000,maxval:99999,minlength:5,maxlength:5},
                {name:'PickupPlaceCity',title:'Hämtort',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                {name:'DeliveryPlaceName',title:'Leveransnamn',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                {name:'DeliveryPlaceStreet',title:'Leveransadress',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                {name:'DeliveryPlacePostCode',title:'Leveranspostnr',required:true,minval:10000,maxval:99999,minlength:5,maxlength:5},
                {name:'DeliveryPlaceCity',title:'Leveransort',required:true,minval:null,maxval:null,minlength:null,maxlength:50},

                // {name:'ContactEmail',title:'Epost',required:true,minval:null,maxval:null,minlength:null,maxlength:50},
                // {name:'ContactPhone',title:'Mobiltelefon',required:true,minval:null,maxval:null,minlength:null,maxlength:25},
                {name:'DeliveryPhone',title:'Mobiltelefon (mottagare)',required:true,minval:null,maxval:null,minlength:null,maxlength:25},
            ]
        },
        basics: {
            products: [
            ],
            packageTypes: [
                // { TypeOfColli: "BA", PackageType: "Fat", PrintText: "FAT" },
                { TypeOfColli: "BE", PackageType: "Bunt", PrintText: "BUNT" },
                // { TypeOfColli: "BL", PackageType: "Bal", PrintText: "BAL" },
                // { TypeOfColli: "BO", PackageType: "Flaska", PrintText: "FLSK" },
                // { TypeOfColli: "BX", PackageType: "Låda", PrintText: "LÅDA" },
                // { TypeOfColli: "CON", PackageType: "Container (sjöfrakt)", PrintText: "CONT" },
                { TypeOfColli: "CR", PackageType: "Häck", PrintText: "HÄCK" },
                { TypeOfColli: "CT", PackageType: "Kartong", PrintText: "KART" },
                // { TypeOfColli: "CX", PackageType: "Dunk", PrintText: "DUNK" },
                { TypeOfColli: "DR", PackageType: "Trumma", PrintText: "TRUM" },
                // { TypeOfColli: "EP", PackageType: "EUR-pall", PrintText: "EURP" },
                // { TypeOfColli: "NE", PackageType: "Oemballerat", PrintText: "OEMB" },
                { TypeOfColli: "OP", PackageType: "Envägspall", PrintText: "PALL" },
                // { TypeOfColli: "PC", PackageType: "Paket", PrintText: "PKT" },
                // { TypeOfColli: "RO", PackageType: "Rulle", PrintText: "RULL" },
                // { TypeOfColli: "SA", PackageType: "Säck", PrintText: "SÄCK" },
                // { TypeOfColli: "TK", PackageType: "Tank, rektangulär", PrintText: "TANK" },
                { TypeOfColli: "XP", PackageType: "Pall (övriga)", PrintText: "PALL" },
            ],
            serviceTypes: [
                {
                    "ServiceTypeId": 15,
                    "Name": "Manuell order",
                    "TsrCode": null
                }
            ]
        }
    },
 
]

export default {
    components: { bookingltd, queryviewlistdetail,lmodal },
    data() {
        return {
            newBookingVisible: false,
            currTemplate: null,
            currBook: null,
            currId: null,
            myModal: false,
            isBusy: false,
            extrafilter: null,
        }
    },
    created() {        
        this.extrafilter=JSON.stringify([{field:'Id',type:'=',eq:'-1'}]); //default show nothing
        let flt = [{field:'UserId',type:'=',eq: usr.GetUser().userid}];
        this.extrafilter = JSON.stringify(flt);
    },
    methods: {
        getTemplates() {
            return templates.filter(x => usr.HasPermission(x.permission));
        },
        startNewBooking(t) {
            if (this.newBookingVisible) {
                //Should never happen
                alert('En bokning håller redan på att skapas. Slutför den först.');
                return;
            }

            this.currTemplate = t;
            this.currBook = this.createNewBookingFromTemplate(t);
            this.newBookingVisible = true;
        },
        createNewBookingFromTemplate(t) {
            //TODO: Should be get this from server side?            
            var m = new moment();
            let b = { DeliveryDateText: m.format("YYYY-MM-DD HH:mm"), collis: [], Sender: t.name };
            if (t.default)
                b = { ...b, ...t.default };

            let book = { booking: b, collis: [] };
            return book;
        },
        onCloseDetails(e) {
            this.myModal = false;
            this.$router.go();//Full reload
        },
        BookingChanged(bid) {
            this.newBookingVisible=false;
            this.setCurrent(bid);
        },
        oncurrentkeychanged(row) {
            this.onclick(row);
        },
        async onclick(row) {
            this.setCurrent(row._key);
        },
        setCurrent(id) {
            this.currId = id;
            this.myModal = true;
            this.isBusy = true;
            api.get("/api/Booking/GetDetails?id=" + this.currId).then((res) => {
                this.currBook = res.data; //Ändrat!!!!
                // this.currBook = res.data.booking;
                // this.currBook.collis = res.data.collis;

                let snd = this.currBook.booking.Sender;
                let t = this.getTemplates().find(x => x.name == snd);
                if (!t) {
                    alert('Du verkar inte ha rättighet att öppna bokningen.');
                    return;
                }
                this.currTemplate = t;
                this.myModal = true;
                this.isBusy = false;
            });
        },
        ReleaseBooking(b) {
            let id = b.booking.Id;
            var bd = [id];
            api.post('/api/Booking/Release', bd).then(res => {
                if (res.data.length > 0) {
                    alert(res.data.join('\n'));
                }
                this.setCurrent(id);
                //this.$router.go();//Full reload
            }
            )
        },
        DeleteBooking(b) {
            api.delete('/api/Booking/RemoveBooking?id=' + b.booking.Id).then(res => {
                if (res.data) {
                    alert(res.data);
                    return;
                }
                alert('Bokning borttagen');
                this.newBookingVisible = false;
                this.myModal = false;
                this.$router.go();//Full reload
            });
        },
        openWindow(lnk) {
            window.open(lnk);
        }
    }
}

</script>